export const COLORS = {
  BlackBackground: '#000000',
  textPrimary: '#ffffff',
  GOLD: '#000000',
  iconColor: '#ffffff',
  primary: '#000000',
  secondary: '#424242',
  success: '#4caf50',
  error: '#f44336',
  warning: '#ff9800',
  info: '#212121',
};
